import React from "react";
import { Box, Button, Card, CardContent, CircularProgress, Typography } from "@material-ui/core";
import { resolveErrorMessage } from "../../../util";
import moment from "moment";
import { sendWelcomeOnboardingEmails } from "../../../actions/scripts";

const SendWelcomeOnboarding = () => {
  const [totalSent, setTotalSent] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleSendEmail = async () => {
    setLoading(true);
    setError(null);
    setTotalSent(null);

    try {
      const response = await sendWelcomeOnboardingEmails();
      setTotalSent(response);
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      setError(`Erro ao executar o script: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  const yesterday = moment().subtract(1, "day").format("DD/MM/YYYY");

  return (
    <Card>
      <CardContent>
        <Typography gutterBottom color="primary" variant="h6">
          Enviar e-mail de boas vindas do onboarding
        </Typography>

        <Typography gutterBottom variant="body2">
          sendWelcomeOnboardingEmail
        </Typography>
        <Typography gutterBottom variant="body2">
          Dia de referência: {yesterday}
        </Typography>

        <Typography gutterBottom variant="body1">
          Este script envia o email de boas vindas(onboarding) para usuários aptos do dia anterior que ainda não receberam este.
        </Typography>
        <Typography gutterBottom variant="body1" color="primary">
          Roda automaticamente todos os dias às <b>8hrs</b>.
        </Typography>

        {totalSent !== null && (
          <Typography gutterBottom variant="body1" color="primary" style={{ fontWeight: "bold" }}>
            Total de e-mails enviados: {totalSent}
          </Typography>
        )}

        {error && (
          <Box mt={2}>
            <Typography color="error">{error}</Typography>
          </Box>
        )}

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button variant="outlined" color="primary" onClick={handleSendEmail} disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Executar agora"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SendWelcomeOnboarding;
